import React, {useState} from 'react'
import { CreateAsset } from './CreateAsset'
import { List } from './List'
import propsPanelSearch from "../../../../../../assets/svg/propsPanelSearch.svg";
import assetAddIcon from "../../../../../../assets/svg/assetAddIcon.svg";
import minimizeIcon from "../../../../../../assets/svg/minimizeIcon.svg";
import {useSelector} from 'react-redux';
import {AppState} from '../../../../../../stateManager/store';

export const Assets = (props:any) => {
  const [addAssetState, setAddAssetState] = useState(false);
  const [searchState, setSearchState] = useState(false);
  const [searchData, setSearchData] = useState<any>(null);
  
  const { isAssetInstanceSelected, assetEditModeEnabled } = useSelector((state: AppState) => {
    const formJson = state.formJson
    return {
      isAssetInstanceSelected: formJson.isAssetInstanceSelected,
      assetEditModeEnabled: formJson.assetEditMode.isEnabled
    }
  })
  return (
    <div style={{fontSize: 13}} className="space-y-2">
      <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#FFF", borderBottom: '1px solid #F2F3F9', padding: '8px'}}>

        <div style={{color: "#292D32", fontWeight: 700, fontSize:"14px"}}>Assets</div>
        <div style={{display: "flex"}}>
          <img src={propsPanelSearch} 
            onClick={() => {searchState ? setSearchState(false) : setSearchState(true); setAddAssetState(false)}} 
            style={{margin: "0px 11px", cursor:"pointer"}} alt="searchIcon" height="15px" width="15px" 
          />
          <img src={assetAddIcon} 
            onClick={() => {addAssetState ? setAddAssetState(false) : setAddAssetState(true); setSearchState(false)}} 
            style={{cursor:"pointer", margin: "0px 11px"}} alt="searchIcon" height="15px" width="15px" 
          />
        </div>
      </div>
      {addAssetState && <CreateAsset assetEditModeEnabled={assetEditModeEnabled} />}
      {searchState && <div className="w-full px-3 py-2">
        <input
          disabled={assetEditModeEnabled}
          className="w-full font-medium flex-1 focus:outline-none p-2"
          type="text"
          placeholder="Enter asset name"
          value={searchData}
          onChange={(e) => {setSearchData(e.target.value)}}
          style={{
            borderBottom: "2px solid rgba(125, 132, 146, 0.294)",
          }}
        />
      </div>}
      <List searchData={searchData} />
    </div>
  );
};
